import _ from "lodash";
import { useEffect, useState } from "react";
import { Button, Dropdown, Form, FormProps, Input, Modal, Segment, Table, TextArea } from "semantic-ui-react";
import { dialogControl } from "../../controls/dialog-control";
import { useCurrentUser } from "../../hooks/auth-hook";
import { ModalControlData, useModalControl } from "../../hooks/commonHooks";
import { useFormConnect, useFormData } from "../../hooks/formHooks";
import { restRequest } from "../../http";
import { PageData } from "../../models/common_model";
import { ModelData } from "../../models/rma_tracking_model";
import { fieldError } from "../../utils";
import { Page } from "./Page";

export function RootCauseComponent(props: { }) {
    const currentUser = useCurrentUser();
    const [searchData, setSearchField] = useFormData<any>({});
    const [models, setSearchData] = useFormConnect<any, PageData<ModelData>>({}, 'commons/root_causes/search');

    const editModalControl = useModalControl();
    const [currentEditId, setCurrentEditId] = useState<number>();
    const [reloadNumber, setReloadNumber] = useState(0);

    return <>
        <Segment.Group>
            <Segment attached="top">
                <Form onSubmit={e => {
                    e.stopPropagation();
                    setSearchData(searchData);
                }}>
                    <Form.Group>
                        <Form.Field inline>
                            <Input placeholder="Name" name="name" value={searchData['name'] || ''} onChange={setSearchField} />
                        </Form.Field>
                        <div><Button icon="search" type="submit"></Button></div>
                    </Form.Group>
                </Form>
            </Segment>
            <Segment attached="bottom">
                <Table striped>
                    <Table.Header>
                        <Table.Row>
                            <th>Name</th>
                            <th>Description</th>
                            <th>
                                {currentUser.permissions.commons.root_cause.create && <Button color="blue" icon="add" content="Root Cause" size="mini" onClick={e => {
                                    setCurrentEditId(undefined);
                                    editModalControl.setOpen(true);
                                }} />}
                            </th>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {models?.items.map(model => {
                            return <tr key={model.id}>
                                <td>{model.name}</td>
                                <td>{model.description}</td>
                                <td>
                                    {currentUser.permissions.commons.root_cause.update && <Button onClick={e => {
                                        setCurrentEditId(model.id);
                                        editModalControl.setOpen(true);
                                    }} color="blue" icon="edit" size="mini" />}

                                    {currentUser.permissions.commons.root_cause.delete && <Button onClick={e => {
                                        dialogControl.deletionConfirm(model.name, argee => {
                                            if (argee) {
                                                return restRequest(`commons/root_causes/${model.id}`, null, 'delete').then(() => {
                                                    setSearchData((searchData: any) => ({ ...searchData, refresh: (searchData.refresh || 1) + 1 }));
                                                })
                                            }
                                            return Promise.resolve()
                                        })
                                    }} color="red" icon="delete" size="mini" />}
                                </td>
                            </tr>
                        })}
                    </Table.Body>
                </Table>
                <Page data={models} updatePage={setSearchData}></Page>
            </Segment>
        </Segment.Group>

        <Editor id={currentEditId} modelControl={editModalControl} onFinish={result => {
            setSearchData((searchData: any) => ({ ...searchData, refresh: (searchData.refresh || 1) + 1 }));
            editModalControl.setOpen(false)
            setReloadNumber(n => n + 1);
        }}></Editor>
    </>
}

function Editor(props: { id?: number, modelControl: ModalControlData, onFinish: (data: ModelData) => void }) {
    const { id, modelControl, onFinish } = props;
    const isCreate = !id;

    const [data, setField, setData] = useFormData<ModelData>({} as any);
    const [invalidError, setInvalidError] = useState<any>({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setData({ admin: false } as any);
        setInvalidError({});
        if (id) {
            setLoading(true);
            restRequest<ModelData>('commons/root_causes/' + id).then(setData).finally(() => setLoading(false))
        } else {
            setData(d => ({ ...d }))
        }
    }, [id])

    const onSubmit = (event: React.FormEvent<HTMLFormElement>, formProps: FormProps) => {
        event.stopPropagation();
        event.preventDefault();

        setLoading(true);

        restRequest<ModelData>(`commons/root_causes${isCreate ? '' : '/' + id}`, data, isCreate ? 'post' : 'put').then(result => {
            props.onFinish(result);
            setInvalidError({});
        }, resp => {
            if (resp.status === 2) {
                setInvalidError(resp.data);
            }
        }).finally(() => setLoading(false));
    }

    return <>
        <Modal {...props.modelControl.props} size="large">
            <Modal.Header>{isCreate ? 'Create' : 'Update'} Root Cause </Modal.Header>
            <Modal.Content>
                <Form onSubmit={onSubmit} loading={loading}>

                    <Form.Group widths="equal">
                        <Form.Input label="Name" name="name" value={data['name'] || ''} onChange={setField} required error={fieldError('name', invalidError)}>
                        </Form.Input>
                    </Form.Group>
                    <Form.Group widths="equal">
                        <Form.Input label="Description" error={fieldError('description', invalidError)}>
                            <TextArea name="description" value={data.description || ''} onChange={setField} />
                        </Form.Input>
                    </Form.Group>
                    <div>
                        <Button primary>Submit</Button>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <Button as="a" onClick={e => props.modelControl.setOpen(false)}>Cancel</Button>
                    </div>
                </Form>
            </Modal.Content>
        </Modal>
    </>
}